import React, { useState, useEffect } from 'react';
import {
    Box,
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
    useDisclosure,
    Text,
} from '@chakra-ui/react'
import { Link } from "react-router-dom";


import { fetchWrapper } from '../../helpers';
import CustomModalLink from '../../components/CustomModalLink';
import CustomModal from '../../components/CustomModal';
import PageLoader from '../../components/Loader/PageLoader';
import Create from '../sale_channel/Create';
import Edit from '../sale_channel/Edit';
import Header from '../../components/Header';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

function ChannelList() {

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { onOpen: onOpenEdit } = useDisclosure();
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [modalEditView, setModalEditView] = useState(false)
    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false);
    const meClose = () => {

        onClose();
    }

    useEffect(() => {
        loadList();
    }, [])

    const loadList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/sale_channel/list`;
        const data = await fetchWrapper.get(url)
        setList(data.data);
        setLoading(false)
    }



    const meCloseEdit = () => {

        setIsOpenEdit(false);

    }

    const meEdit = (rs) => {
        setIsOpenEdit(true);
        setModalEditView(<Edit meCloseEdit={meCloseEdit} rs={rs} loadList={loadList} />)
    }


    return (
        <>
            <Header />
            <PageLoader isLoading={loading} />
            <CustomModalLink
                showModalButtonText="Status Edit"
                modalHeader="Status Edit"
                isOpenEdit={isOpenEdit}
                onCloseEdit={meCloseEdit}
                onOpenEdit={onOpenEdit}

                modalBody={modalEditView}
            />
            <BoxWrapper>
                <div >

                    <HStack justifyContent="space-between">
                        <Box>
                            <Text fontSize="32px" fontWeight="300" color="#000000" my="0px" fontFamily="'Open Sans', sans-serif">Sales Contract</Text>
                        </Box>
                        <Box>
                            <HStack>

                                <Box>
                                    <CustomModal
                                        showModalButtonText="Add New Sales Contract"
                                        modalHeader="Add Sales Contract"
                                        isOpen={isOpen}
                                        onClose={onClose}
                                        onOpen={onOpen}
                                        modalBody={<Create meClose={meClose} loadList={loadList} />}
                                    />
                                </Box>
                            </HStack>
                        </Box>
                    </HStack>



                    <div className="table_section">
                        <TableContainer width="100%">
                            <Table variant='simple' width="100%" borderWidth="1px" borderColor="#CCCCCC" borderStyle="solid">
                                <Thead >
                                    <Tr>

                                        <Th>Name</Th>



                                        <Th></Th>
                                        <Th></Th>






                                    </Tr>
                                </Thead>

                                <Tbody fontSize="14px">
                                    {list.map((rs, index) => {
                                        return (

                                            <Tr key={rs?.id || index}>
                                                <Td>{rs.name}</Td>


                                                <Td>
                                                    <Link
                                                        to={`/sales-contract/${rs.id}`}
                                                        state={{ id: rs.id }}
                                                    >
                                                        View Price List
                                                    </Link>
                                                </Td>

                                                <Td style={{ color: "#0000EE" }}>
                                                    <a href="#" onClick={() => meEdit(rs)}>Edit</a>
                                                </Td>

                                                {/* <Td>

                                                    <Link
                                                        to={`/other-channel-price/${rs.id}`}
                                                        state={{ id: rs.id }}
                                                    >
                                                        View Other Channel Price List
                                                    </Link>

                                                </Td> */}




                                            </Tr>

                                        )
                                    })}







                                </Tbody>


                            </Table>

                        </TableContainer>
                    </div>

                </div>
            </BoxWrapper>
        </>
    )
}


export default ChannelList
